
const Input = (props) => {
    return(
        <>
            <label style={!props.label ? {display: 'none'} : {}}>{props.label}</label>
            <input
                type={props.showPass ? 'text' : props.type}
                checked={props.checked}
                name={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.handleChange}
                required={props.type !== 'checkbox'} />
        </>
    )
}

export default Input